import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideFacility() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ホール貸館のご案内
          </Typography>
          　デーリー東北新聞社は、本社１階の「デーリー東北ホール」と６階の「メディアホール」を一般の方にも有料でお貸ししています。各種文化活動や講演会、さまざまな交流の場としてご活用ください。利用案内や料金等は以下の「詳細」でご確認ください。
          {/*
          　デーリー東北ホール及びメディアホール（以下「当ホール」）は、八戸市近郊にお住いの皆様による文化的活動の発信地としてご利用いただくことを目的に運営しております。<br/>
          　多くの方に気持ちよくご利用いただくため、ご理解とご協力をお願いいたします。<br/>
          */}
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/hall" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            南部会館
          </Typography>
          　南部会館は集会施設として開放しています。和室４室、板の間１室、舞台を備えており、謡・舞踊などの発表会や展示会をはじめ、講習会、お茶会、各種会議等に利用されています。どうぞお気軽にご利用ください。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.nanbukaikan.com/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            しんぶんカフェ
          </Typography>
          　デーリー東北新聞社は、八戸市城下１丁目の本社敷地内に「しんぶんカフェ」を開設しました。隣接するデーリー東北ホールと連動した施設で、地域コミュニティーの活動拠点としての機能を一層強化させました。<br/>
          　しんぶんカフェは、木造平屋建て床面積２８８・０７平方メートル。店舗内部はカフェコーナーと寿司・和食コーナーに分割されています。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/company-cafe.html" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

      </div>
    </div>
  );
}

export default GuideFacility;
